import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propShape } from '../../../helpers/custom-prop-types';
import Hover from '../../Ui/System/Hover';
const BreadcrumbColumn = (props) => {
    const { column: { link, skeleton, text }, } = props;
    if (skeleton) {
        return (_jsx("li", Object.assign({ className: 'breadcrumb_col' }, { children: _jsx("span", { className: 'is-skeleton' }) })));
    }
    return (_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'breadcrumb_col' }, { children: link ? _jsx(Link, Object.assign({ to: link }, { children: text })) : _jsx("span", { children: text }) }), text) }));
};
BreadcrumbColumn.propTypes = {
    column: propShape().isRequired,
};
export default BreadcrumbColumn;
